var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-Experience-cat__replies"},[_c('nested-reply',{attrs:{"node":_vm.replies,"is-blog":_vm.isblog,"is-sponsors":_vm.isSponsors,"post-id":_vm.postid}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }